module.exports = __webpack_public_path__ + "static/img/原料泡泡-1.1b6c12e2.png";